import React from 'react';
import ProyectoContainer from '../containers/ProyectoContainer';

export default function RouteProyecto(routeProps){
    return <ProyectoContainer 
                {...routeProps} 
                idProject={routeProps.match.params.idProject} 
                search={routeProps.location.search} />;
} 